import { Skeleton } from '@/components/ui/Skeleton';
import { Header, List } from '../SettingsLayout';

function SkeletonList() {
  return (
    <>
      <Header>
        <Skeleton className='h-4 w-full max-w-[30%]' />
        <Skeleton className='h-4 w-full max-w-[50%]' />
      </Header>
      <List>
        <List.Header>
          <Skeleton className='h-4 w-24' />
        </List.Header>
        <List.Body>
          <Skeleton className='h-8 w-full' />
          <Skeleton className='h-8 w-full' />
          <Skeleton className='h-8 w-full' />
        </List.Body>
      </List>
    </>
  );
}

export default SkeletonList;
